<script setup lang="ts">
import { useSessionStore } from '../../../stores';
import { Session } from '../../../types/session';
import VideoPlayer from '../../General/VideoPlayer.vue';
import isaacSadImg from '../../../assets/imgs/isaac-sad.png'
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../configs/text';

const sessionStore = useSessionStore()

const { t } = useI18n()
</script>

<template>
    <div v-if="sessionStore.classContent?.[Session.lecture]?.videoUrl" class="w-full h-full rounded-lg overflow-hidden">
        <VideoPlayer :src="sessionStore.classContent[Session.lecture].videoUrl" />
    </div>
    <div v-else class="w-full h-full flex flex-col gap-4 items-center justify-center rounded-lg bg-neutral-200">
        <img :src="isaacSadImg" />
        <div class="text-center">{{ t(TEXT.no_lecture_available) }}</div>
    </div>
</template>